import { render, staticRenderFns } from "./CropperImage3.vue?vue&type=template&id=fb60f532&"
import script from "./CropperImage3.vue?vue&type=script&lang=js&"
export * from "./CropperImage3.vue?vue&type=script&lang=js&"
import style0 from "./CropperImage3.vue?vue&type=style&index=0&id=fb60f532&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports